import script from "./ReferralView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralView.vue?vue&type=script&setup=true&lang=ts"

import "./ReferralView.vue?vue&type=style&index=0&id=26d823c8&lang=css"

const __exports__ = script;

export default __exports__